<template>
  <div class=" my-10">
    <div class="bg-white overflow-hidden shadow rounded-lg mt-10">
      <div class="border-b border-gray-200 px-4 py-5 sm:px-6">
        <h1>Contextual chat extension</h1>
      </div>
      <div class="px-4 py-5 sm:p-6">
        <div class="mt-2 mb-6 text-sm leading-5 text-gray-500">
          When you are chatting with your customers in WhatsApp you will get
          contextual information about the customer on the right side. You don't
          have to go search their order details. You can answer the exact
          queries with the relevant order information about the customer.
        </div>
        <img src="../../assets/contextextn.png" />
      </div>
      <div
        class="bg-white shadow sm:rounded-lg"
        v-if="!shouldShowExtensionLink"
      >
        <div class="px-4 py-5 sm:p-6">
          <div class="sm:flex sm:items-start sm:justify-between">
            <div>
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Upgrade to use this feature
              </h3>
              <div class="mt-2 max-w-xl text-sm leading-5 text-gray-500">
                <p></p>
              </div>
            </div>

            <div
              class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
            >
              <span class="inline-flex rounded-md shadow-sm">
                <button
                  class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                  type="button"
                  @click="gotoPlans"
                  v-if="store.plan === 'limited_free'"
                >
                  <span
                    class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                    >Upgrade now</span
                  >
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="bg-white shadow sm:rounded-lg" v-if="shouldShowExtensionLink">
        <div class="px-4 py-5 sm:p-6">
          <div class="sm:flex sm:items-start sm:justify-between">
            <div>
              <h3 class="text-lg leading-6 font-medium text-gray-900">
                Download Chrome Extension
              </h3>
              <!-- <div class="mt-2 max-w-xl text-sm leading-5 text-gray-500">
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Recusandae voluptatibus corrupti atque repudiandae nam.
              </p>
            </div> -->
            </div>

            <div
              class="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
            >
              <span class="inline-flex rounded-md shadow-sm">
                <button
                  class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                  type="button"
                  @click="openDownload"
                >
                  <span class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium">Add to chrome</span>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="bg-white shadow sm:rounded-lg mt-4"
      v-if="shouldShowExtensionLink"
    >
      <div class="px-4 py-5 sm:p-6">
        <div class="flex flex-row">
          <div class="w-3/4 pr-4">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Chat Extension API Key
            </h3>
            <div>
              <label
                for="comment"
                class="block text-sm font-medium leading-6 text-gray-900"
                >API Key</label
              >
              <div class="mt-2">
                <textarea
                  rows="4"
                  :value="apiKey"
                  name="comment"
                  id="comment"
                  class="block w-full rounded-md  text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:py-1.5 sm:text-sm sm:leading-6 border"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="w-1/4 flex items-center justify-center">
            <span class="inline-flex rounded-md shadow-sm">
              <button
                type="button"
                class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                @click="copyAPIKey"
              >
                <span
                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                  >Copy</span
                >
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      browserPreference: "",
      isSaving: false,
      isSaved: false,
      apiKey: ""
    };
  },
  computed: {
    store() {
      return this.$store.getters.getStore;
    },
    shouldShowExtensionLink() {
      let result = true;
      const store = this.$store.getters.getStore;

      if (store && store.plan === "limited_free") {
        result = false;
      }

      return result;
    }
  },
  created() {
    this.$store.dispatch("getCRMAPIKey").then(response => {
      this.apiKey = response.token;
    });
  },
  methods: {
    openDownload() {
      window.open(
        "https://chrome.google.com/webstore/detail/chat-crm-carthike/dlbielcbbioanbfnkhcgegkgeaojiopo",
        "_blank"
      );
    },
    gotoPlans() {
      history.pushState({}, null, "/settings");
      this.$router.push({ path: "/settings" });
      // this.$router.push({ name: "Plan" });
    },
    copyAPIKey() {
      navigator.clipboard.writeText(this.apiKey);

      // Alert the copied text
      alert("API copied :) Goto web.whatsapp.com and paste the key");
    },

    saveBrowserPreference() {
      this.isSaving = true;
      this.$store
        .dispatch("updateConfig", {
          requestParams: {
            browserPreference: this.browserPreference
          }
        })
        .then(() => {
          this.isSaving = false;
          this.isSaved = true;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
